import { render, staticRenderFns } from "./customerConfirmation.vue?vue&type=template&id=5e9d6793&scoped=true&"
import script from "./customerConfirmation.vue?vue&type=script&lang=js&"
export * from "./customerConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./customerConfirmation.vue?vue&type=style&index=0&id=5e9d6793&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9d6793",
  null
  
)

export default component.exports